<form
    class="form"
    [formGroup]="courseForm"
    (ngSubmit)="onSubmit(courseForm.value)"
>
    <div class="form-container">
        <div class="form-left">
            <div class="field  ">
                <div class="field__label-input-wrap">
                    <label
                        for="name"
                        class="label"
                    >
                        Course Name
                    </label>
                    <input
                        class="input input--large"
                        id="name"
                        [class.input--invalid]="formErrors.courseName"
                        formControlName="courseName"
                        uppercase
                        maxlength="500"
                    >
                    <div
                        *ngIf="formErrors.courseName"
                        class="error-message field__error-message"
                    >
                        {{ formErrors.courseName }}
                    </div>
                </div>
            </div>
            <div class="field ">
                <div class="field__label-input-wrap">
                    <label
                        for="type"
                        class="label"
                    >
                        Course Type
                    </label>
                    <select
                        class="input input--select-menu input--xlarge"
                        [class.input--invalid]="formErrors.courseUsageTypeId"
                        id="type"
                        formControlName="courseUsageTypeId"
                        required
                    >
                        <option value>Select</option>
                        <option value="1">Adult Critical Care</option>
                        <option value="6">Asthma Educator</option>
                        <option value="2">General Respiratory Care</option>
                        <option value="3">Neonatal/Pediatric</option>
                        <option value="4">Pulmonary Function Technology</option>
                        <option value="5">
                            Sleep Disorders Testing and Therapeutic Intervention
                        </option>
                        <!-- <option value="6">Asthma Educator</option> -->
                    </select>
                    <div
                        *ngIf="formErrors.courseUsageTypeId"
                        class="error-message field__error-message"
                    >
                        {{ formErrors.courseUsageTypeId }}
                    </div>
                </div>
            </div>
            <fieldset class="field-group">
                <legend class="label field-group__label">Course Category:</legend>
                <ul class="field-list">
                    <li class="field field--inline field-list__item">
                        <input
                            class="input input--radio"
                            [value]="1"
                            id="category-1"
                            formControlName="courseCategoryId"
                            name="courseCategoryId"
                            [class.input--invalid]="formErrors.courseCategoryId"
                            type="radio"
                        >
                        <label
                            for="category-1"
                            class="label label--inline"
                        >
                            Lecture
                        </label>
                    </li>
                    <li class="field field--inline field-list__item">
                        <input
                            class="input input--radio"
                            [value]="2"
                            id="category-2"
                            formControlName="courseCategoryId"
                            name="courseCategoryId"
                            [class.input--invalid]="formErrors.courseCategoryId"
                            type="radio"
                        >
                        <label
                            for="category-2"
                            class="label label--inline"
                        >
                            Panel
                        </label>
                    </li>
                    <li class="field field--inline field-list__item">
                        <input
                            class="input input--radio"
                            [value]="3"
                            id="category-3"
                            formControlName="courseCategoryId"
                            name="courseCategoryId"
                            [class.input--invalid]="formErrors.courseCategoryId"
                            type="radio"
                        >
                        <label
                            for="category-3"
                            class="label label--inline"
                        >
                            Workshop
                        </label>
                    </li>
                    <li class="field field--inline field-list__item">
                        <input
                            class="input input--radio"
                            [value]="4"
                            id="category-4"
                            formControlName="courseCategoryId"
                            name="courseCategoryId"
                            [class.input--invalid]="formErrors.courseCategoryId"
                            type="radio"
                        >
                        <label
                            for="category-4"
                            class="label label--inline"
                        >
                            Seminar
                        </label>
                    </li>
                    <li class="field field--inline field-list__item">
                        <input
                            class="input input--radio"
                            [value]="5"
                            id="category-5"
                            formControlName="courseCategoryId"
                            name="courseCategoryId"
                            [class.input--invalid]="formErrors.courseCategoryId"
                            type="radio"
                        >
                        <label
                            for="category-5"
                            class="label label--inline"
                        >
                            Symposium
                        </label>
                    </li>
                    <li class="field field--inline field-list__item">
                        <input
                            class="input input--radio"
                            [value]="6"
                            id="category-6"
                            formControlName="courseCategoryId"
                            name="courseCategoryId"
                            [class.input--invalid]="formErrors.courseCategoryId"
                            type="radio"
                        >
                        <label
                            for="category-6"
                            class="label label--inline"
                        >
                            Online Education
                        </label>
                    </li>
                </ul>
                <div
                    *ngIf="formErrors.courseCategoryId"
                    class="error-message field__error-message"
                >
                    {{ formErrors.courseCategoryId }}
                </div>
            </fieldset>
            <div class="form-row">
                <div class="field form-row__item ">
                    <div class="field__label-input-wrap">
                        <label
                            for="hours"
                            class="label"
                        >
                            Hours
                        </label>
                        <input
                            class="input"
                            id="hours"
                            [class.input--invalid]="formErrors.courseHours"
                            formControlName="courseHours"
                            mask="separator.2"
                            decimalMarker="."
                            (ngModelChange)="onAmountChange($event)"
                        >
                        <div
                            *ngIf="formErrors.courseHours"
                            class="error-message field__error-message"
                        >
                            {{ formErrors.courseHours }}
                        </div>
                    </div>
                </div>
                <div class="field form-row__item">
                    <div class="field__label-input-wrap">
                        <label
                            for="completionDate"
                            class="label"
                        >
                            Completion Date
                        </label>
                        <input
                            *ngIf="appSettings.IsCompatibilityMode === true"
                            class="input"
                            [class.input--invalid]="formErrors.completionDate"
                            mask="00/00/0000"
                            id="completionDate"
                            formControlName="completionDate"
                            type="text"
                            placeholder="MM/DD/YYYY"
                        >
                        <input
                            *ngIf="appSettings.IsCompatibilityMode === false"
                            class="input"
                            [class.input--invalid]="formErrors.completionDate"
                            id="completionDate"
                            formControlName="completionDate"
                            type="date"
                            placeholder="mm/dd/yyyy"
                        >
                        <div
                            *ngIf="formErrors.completionDate"
                            class="error-message field__error-message"
                        >
                            {{ formErrors.completionDate }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-actions">
                <input
                    class="button form-actions__item"
                    type="submit"
                    value="{{action}}"
                >
                <button
                    (click)="onCancel($event)"
                    class="button button--secondary form-actions__item"
                >
                    Cancel
                </button>
            </div>
            <div
                *ngIf="formLevelErrors"
                class="error-message field__error-message"
            >
                <p *ngFor="let error of formLevelErrors">{{error}}</p>
            </div>
        </div>
        <div class="form-right">
            <p>
                For BLS, ACLS, NRP and/or PALS: The NBRC will accept CE courses accepted by your state licensing board.
            </p>
            <p>
                If your state does not award credit, six (6) CEU hours will be accepted for successful completion of courses in BLS ACLS, NRP and/or PALS but not
                more than 12 CEU hours will be accepted for any combination of these programs during your five (5) year credential cycle.
            </p>
            <p>
                Click
                <a
                    href="./licensure/list"
                    target="_blank"
                >
                    here
                </a>
                to find your state agency.
            </p>
        </div>
    </div>
</form>
